import React from "react";
import {useFormStatus} from "../../../../../utils/hooks/useFormStatus";
import {useFormik} from "formik";
import {GuideFormFields} from "../../../../../types/formFieldTypes";
import {getAntField} from "../../../../../utils/form";
import {useMutation} from "react-query";
import {api} from "../../../../../api/api";
import {invalidateQueries} from "../../../../../utils/rest";
import {queryKeysGuide} from "../../../../../static/data/queryKeys";
import {Form} from "antd";
import FormStatus from "../../../../../components/form/FormStatus/FormStatus";
import {clearGuideErrors, guideValidate, initialGuideFields} from "../../formData/GuideFormData";
import GuideFormInputs from "../GuideFormInputs/GuideFormInputs";

type GuideAddFormProps = {
    setOpenedForm: React.Dispatch<React.SetStateAction<boolean>>,
    itemLength: number
}

const GuideAddForm: React.FC<React.PropsWithChildren<GuideAddFormProps>> = React.memo(({itemLength}) => {
    const formStatus = useFormStatus()

    const {
        errors, values, touched,
        handleChange, setFieldValue,
        submitForm, setValues, setErrors,
    } = useFormik<GuideFormFields>({
        initialValues: initialGuideFields,
        validateOnChange: false,
        onSubmit: (values: GuideFormFields) => {
            values.number = itemLength + 1;
            mutate(values)
        },
        validate: guideValidate
    })

    const antField = getAntField<GuideFormFields>(values, errors, touched)

    const {
        mutate
    } = useMutation(
        api.guide.create,
        {
            mutationKey: 'guide-add',
            onSuccess() {
                invalidateQueries(queryKeysGuide[0])
                formStatus.setMessage('Объект успешно добавлен')
                formStatus.setStatus('success')
                setTimeout(clearEditItem, 1000)
            },
            onError(err: Error) {
                console.log('ERROR', err)
                formStatus.setMessage(`Ошибка: ${err.message}`)
                formStatus.setStatus('error')
                setTimeout(clearEditItem, 4000)
            },
            onMutate() {
                formStatus.setMessage('Отправка данных')
                formStatus.setStatus('fetching')
            }
        }
    )

    const clearForm = () => {
        setValues(initialGuideFields)
        setErrors(clearGuideErrors)
    }

    const clearEditItem = () => {
        clearForm()
        setTimeout(formStatus.reset, 300)
    }

    return (
        <Form fields={[
            antField('name'),
            antField('path'),
            antField('text'),
        ]}>
            <GuideFormInputs
                handleChange={handleChange}
                clearForm={clearForm}
                submitForm={submitForm}
                values={values}
            />
            <FormStatus formStatus={formStatus} />
        </Form>
    )
})

export default GuideAddForm;